import { accept, create, getAll, reject } from "api/companyAccessRequest";

export const getRequests = (id) => (dispatch, getState) =>
  dispatch({
    type: "COMPANY_ACCESS_REQUEST_GET_ALL",
    payload: getAll(id || getState().currentUser.company.id),
  });

export const acceptRequest = (id) => (dispatch) =>
  dispatch({
    type: "COMPANY_ACCESS_REQUEST_ACCEPT",
    payload: accept(id),
    meta: { id },
  });

export const rejectRequest = (id) => (dispatch) =>
  dispatch({
    type: "COMPANY_ACCESS_REQUEST_REJECT",
    payload: reject(id),
    meta: { id },
  });

export const createRequest = (companyId) => (dispatch) =>
  dispatch({
    type: "COMPANY_ACCESS_REQUEST_CREATE",
    payload: create(companyId),
    meta: { companyId },
  });
